/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="88.92"
        height="88.92"
        viewBox="0 0 88.92 88.92"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#ffb81c"
          d="M42.57 10.74v3.46l-.54.1-.54.11a8.31 8.31 0 0 0-6.26 5.08 10.45 10.45 0 0 0-.72 4.73 8.12 8.12 0 0 0 4.35 6.91 33.78 33.78 0 0 0 3.63 1.63c1.53.64 3.07 1.23 4.59 1.87a2.76 2.76 0 0 1 1.73 3 3 3 0 0 1-2.43 3 8.82 8.82 0 0 1-1.92.21 4.77 4.77 0 0 1-4.88-3.57c-.14-.42-.25-.86-.38-1.33l-5.8 1.5a12.06 12.06 0 0 0 2.81 5.74 9.83 9.83 0 0 0 6.36 2.94v4.48h3.75v-4.38c.76-.16 1.49-.27 2.2-.46a8.62 8.62 0 0 0 6.11-5 10 10 0 0 0 .7-6.06 7.94 7.94 0 0 0-4.06-5.7 44.85 44.85 0 0 0-5.55-2.43c-1.14-.45-2.25-1-3.34-1.52a2.39 2.39 0 0 1-1.25-1.51 3.38 3.38 0 0 1 2.37-4.27 3.93 3.93 0 0 1 3.88 1A7.27 7.27 0 0 1 49 22.68c.13.28.25.57.38.87l5.19-2.14a10.39 10.39 0 0 0-1.91-3.92 9.14 9.14 0 0 0-6.31-3.28v-3.47Z"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#0e497b"
          d="M87.67 37.39a1.24 1.24 0 0 1 1.24 1.12v49.16a1.25 1.25 0 0 1-1.12 1.24H1.25A1.24 1.24 0 0 1 0 87.8V38.64a1.25 1.25 0 0 1 2.49-.13v47.91h83.92V38.64a1.26 1.26 0 0 1 1.12-1.25Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M74.33 0a1.24 1.24 0 0 1 1.24 1.12v46.53a1.25 1.25 0 0 1-2.49.13V2.5H15.84v45.15a1.26 1.26 0 0 1-1.12 1.25h-.13a1.26 1.26 0 0 1-1.25-1.12V1.25A1.24 1.24 0 0 1 14.46 0h59.87Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M87 37.6a1.25 1.25 0 0 1 1.74.34 1.24 1.24 0 0 1-.24 1.65l-.11.08L45.15 68.6a1.24 1.24 0 0 1-1.26.08l-.13-.08L.55 39.67a1.25 1.25 0 0 1 1.28-2.14l.12.07 42.51 28.46Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M73.34 27.54a1.25 1.25 0 0 1 1.64-.3l.12.07 13.33 10.34a1.25 1.25 0 0 1 .23 1.75 1.26 1.26 0 0 1-1.65.3l-.11-.08-13.34-10.33a1.25 1.25 0 0 1-.22-1.75ZM13.82 27.31a1.251 1.251 0 0 1 1.64 1.89l-.11.09L2 39.62a1.25 1.25 0 0 1-1.64-1.88l.1-.09Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'EnvelopeWithPaperMoneyIcon';

export default Icon;
